/**
 * @generated SignedSource<<a374d4b04fde5e4bcd6daf771bb4046a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getCheckoutUrl_item$data = {
  readonly defaultSkuId: string | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "getCheckoutUrl_item";
};
export type getCheckoutUrl_item$key = {
  readonly " $data"?: getCheckoutUrl_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCheckoutUrl_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getCheckoutUrl_item"
};

(node as any).hash = "e81e4fa23fd1660577ac5ad636075c04";

export default node;
